<div class="row mhide">
 <div class="col-md-12 nopad">
 <div class="col-md-12 nopad mobile_hide">
 <div class="w_79" style="position: fixed;z-index: 99; ">
 <div class="tabs-header border-bottom">
 <ul>
 <li *ngFor="let data of appservice.User_Role_Menu" [className]="appservice.URL_Location==data.Link ? 'active' : ''" class="" > <a (click)="appservice.load_page(data.Link)">{{data.Menu}}</a></li>
 </ul>
 </div>
 <div class="right-corner">
 <div class="dropdown" style="display: inline-flex;">
 <a class="dropdown-toggle addbtn1" (click)="addReset()" data-toggle="tooltip" data-placement="bottom" title="Add New">
 <i class='bx bx-list-plus'></i>
 </a>
 <a style="padding-left: 10px;padding-right: 10px;" class="dropdown-toggle " (click)="this.display()" data-toggle="tooltip" data-placement="bottom" title="Refresh">
 <i class='bx bx-rotate-left'></i>
 </a>
 </div>
 </div>
 </div>
 </div>
 
 <div class="col-md-12 nopad">
 <div class="spin_block" *ngIf="appservice.isload">
 <div class="d-flex justify-content-center">
 <div class="spinner-border text-primary" role="status">
 <span class="sr-only">Loading...</span>
 </div>
 </div>
 </div>
 <div class="m_2 res_table">
 <div class="search-bar_Ext mhide show_bar " style="right: 120px;">
 <li class="bx bx-left-arrow-alt mshow search_back"></li>
 <input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" class="search-form-control text" placeholder="Search...">
 </div>
 <p-table #dt class="table table-striped custom-table" [value]="Rows" [columns]="cols">
 <ng-template pTemplate="header">
 <tr>
 <th *ngFor="let col of cols" [pSortableColumn]="col.field" width="{{col.width}}" style="white-space: pre">
 {{col.header}}
 <p-sortIcon [field]="col.field"></p-sortIcon>
 </th>
 <th width=90>Action</th>
 </tr>
 </ng-template>
 <ng-template pTemplate="body" let-rowData let-car>
 <tr [pSelectableRow]="rowData">
 <td *ngFor="let col of cols">
 {{car[col.field]}}
 </td>
 <td class="text-right" style="white-space: pre">
 <a href="javascript:" style="font-size: 18px;padding: 5px" title="Edit" (click)="onEdit(rowData)"><i class="bx bxs-pencil m-r-5"></i></a>
 <a title="Delete" style="font-size: 18px;padding: 5px;color: firebrick" (click)="onDelete(rowData.UM_ID)"><i class="bx bxs-trash m-r-5"></i></a>
 </td>
 </tr>
 </ng-template>
 </p-table>
 </div>
 </div>
 </div>
</div>

<!-- Modernized Mobile View for User Master -->
<div class="row mshow">
 <!-- Sticky Header -->
 <div class="sticky-header">
 <li (click)="appservice.back()" class="bx bx-left-arrow-alt back-btn"></li>
 <label class="header-title-mobile">User Master</label>
 <div class="right-actions-loan">
 <a class="add-btn-round-mini" (click)="addReset()" title="Add User">
 <i class='bx bx-plus'></i>
 </a>
 </div>
 </div>

 <div class="col-md-12 nopad mobile-body-report">
 <!-- Search Box -->
 <div class="search-container-mobile">
 <div class="search-box-mini">
 <i class='bx bx-search'></i>
 <input type="text" (input)="dtMob.filterGlobal($event.target.value, 'contains')" placeholder="Search users...">
 </div>
 </div>

 <div class="spin_block" *ngIf="appservice.isload">
 <div class="d-flex justify-content-center p-5">
 <div class="spinner-border text-primary" role="status"></div>
 </div>
 </div>

 <!-- User Card List -->
 <div class="results-grid px-3">
 <p-table #dtMob [value]="Rows">
 <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
 <div class="report-card-mobile shadow-sm mb-3">
 <div class="card-head" style="background: #f8fafc; margin: -12px -12px 10px -12px; padding: 8px 12px; border-radius: 12px 12px 0 0;">
 <span class="loan-no">#{{rowIndex+1}} User Info</span>
 <span class="loan-date"><i class='bx bx-shield'></i> {{rowData.Rights_Name}}</span>
 </div>

 <div class="card-main">
 <div class="customer" style="font-size: 16px;">{{rowData.UM_Name}}</div>
 <div class="mt-2">
 <div class="d-flex align-items-center text-muted mb-1">
 <i class='bx bx-user-pin mr-2' style="font-size: 14px;"></i>
 <span style="font-size: 13px;">Login ID: <b>{{rowData.UM_LoginID}}</b></span>
 </div>
 <div class="d-flex align-items-center text-muted">
 <i class='bx bx-group mr-2' style="font-size: 14px;"></i>
 <span style="font-size: 13px;">Company: {{rowData.Comp_Name}}</span>
 </div>
 </div>
 </div>

 <div class="card-footer-mini mt-2 pt-2 border-top d-flex justify-content-between align-items-center">
 <div class="footer-stat text-muted" style="font-size: 11px;">Status: Active</div>
 <div class="d-flex gap-2">
 <button (click)="onEdit(rowData)" class="btn btn-sm btn-outline-primary border-0 p-1">
 <i class='bx bx-edit-alt' style="font-size: 18px;"></i>
 </button>
 <button (click)="onDelete(rowData.UM_ID)" class="btn btn-sm btn-outline-danger border-0 p-1">
 <i class='bx bx-trash' style="font-size: 18px;"></i>
 </button>
 </div>
 </div>
 </div>
 </ng-template>
 </p-table>
 </div>
 </div>
</div>
